import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom'; // Agar React Router ishlatayotgan bo'lsangiz

const NotFound = () => {
    const navigate = useNavigate(); // Sahifalar o'rtasida navigatsiya uchun

    return (
        <Result
            status="404" // 404 xato holatini ko'rsatadi
            title="404"
            subTitle="Kechirasiz, siz qidirgan sahifa mavjud emas."
            extra={
                <Button type="primary" onClick={() => navigate('/')}>
                    Bosh sahifaga qaytish
                </Button>
            }
        />
    );
};

export default NotFound;